module.exports = __webpack_public_path__ + "img/starfield.b5f24365.jpg";